import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';

import MenuItem from './MenuItem';

import {
  ROLE,
  ROUTES,
  ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS,
  TABS_CONSTANTS,
  ROUTES_CONSTANTS_CONFIG
} from '../../../const';

const DEFAULT_BODY_CLASS = 'menu-body';

class UserOptions extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.bodyClass = DEFAULT_BODY_CLASS;
  }

  static propTypes = {
    inClassroom: PropTypes.bool,
    role: PropTypes.string,
    layoutSettings: PropTypes.object,
    isAppOnline: PropTypes.any
  };

  renderSettingsItems() {
    const { layoutSettings, role, inClassroom, isAppOnline, archiveEnabled } = this.props;

    const userSettings =
      role === ROLE.INSTRUCTOR
        ? layoutSettings.teacherSettings
        : role === ROLE.COINSTRUCTOR
        ? layoutSettings.coinstructorSettings
        : layoutSettings.studentSettings;

    if (!archiveEnabled) {
      if (indexArchive !== -1) {
        let indexArchive = userSettings.userSections.menuRoutes.indexOf('ARCHIVE');
        userSettings.userSections.menuRoutes.splice(indexArchive, 1);
      }
    }

    return userSettings.userSections.menuRoutes.map(constant => {
      switch (constant) {
        default:
          if (!inClassroom) {
            let title = I18n.t(ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS[constant].translation);
            if (constant === TABS_CONSTANTS.STUDENT_ANALYTICS && role === ROLE.STUDENT) {
              title = I18n.t(ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS[TABS_CONSTANTS.MY_PROFILE].translation);
            }
            let disabledTab = false;
            if (!isAppOnline) {
              disabledTab = ROUTES_CONSTANTS_CONFIG[constant].offlineDisabled;
            }

            return (
              <MenuItem
                key={constant}
                icon={ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS[constant].icon}
                title={title}
                id={constant}
                to={ROUTES[constant] ? ROUTES[constant] : ''}
                disabledOffline={disabledTab}
              />
            );
          }
          return undefined;
      }
    });
  }

  render() {
    return (
      <div id="menu-id" className={this.bodyClass}>
        {this.renderSettingsItems()}
      </div>
    );
  }
}

export default connect(mapStateToProps)(UserOptions);

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    inClassroom: state.router.inClassroom,
    role: state.account.user.role,
    layoutSettings: state.theme.layoutSettings,
    isAppOnline: state.connection.status.online,
    archiveEnabled: state.account.configuration.archiveEnabled
  };
}
